import React, { useState, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  FetchAddAppoientmentVisit,
  FetchVisitReason,
  GetactiveAuth,
  GetappointmentsbyPut,
  GetDeliveryMode,
  GetDoctorsRequest,
  Getmyclinicpatient,
  GetPaymentSources,
  GetResource,
  Getserviceaddress,
  Postappointments,
  updateAgencyDoctor,
  updateAvailableDays,
} from "../../../api/helper";
import { ShowToast } from "../../../helpers/ToastService";
import WeekView from "./AppointmetCalander/WeekView";
import MonthView from "./AppointmetCalander/MonthView";
import AgendaView from "./AppointmetCalander/AgendaView";
import { DropDownManuCustomMulti } from "../../Components/DropDownButton";

const validationSchema = Yup.object().shape({
  patientId: Yup.string().required("Client is required"),
  dob: Yup.string(), // DOB is auto-filled, so not required
  doctorId: Yup.string().required("Provider is required"),
  deliveryMode: Yup.string().required("Appointment type is required"),
  date: Yup.string()
    .required("Date is required")
    .test("is-future-or-today", "Date cannot be in the past", (value) => {
      if (!value) return false;
      const selected = moment(value, "YYYY-MM-DD");
      const today = moment().startOf("day");
      return selected.isSameOrAfter(today);
    }),
  startTime: Yup.string().required("Start time is required"),
  visitReason: Yup.string().required("Visit reason is required"),
  appointmentResource: Yup.string().required("Resource is required"),
  duration: Yup.number()
    .typeError("Duration must be a number")
    .required("Duration is required")
    .min(1, "Minimum duration is 1 minute"),
  appointmentStatus: Yup.string().required("Status is required"),
  serviceLocationId: Yup.string().required("Service location is required"),
  paymentSource: Yup.string(),
  patientIntake: Yup.array()
    .min(1, "At least one patient intake document is required")
    .required("Patient intake is required"),

  providerTask: Yup.array()
    .min(1, "At least one provider task must be selected")
    .required("Provider task is required"),

  "email-confirm": Yup.boolean(),
  "sms-confirm": Yup.boolean(),
  "inapp-confirm": Yup.boolean(),

  "provider-email-confirm": Yup.boolean(),
  "provider-sms-confirm": Yup.boolean(),
  "provider-inapp-confirm": Yup.boolean(),
  repeats: Yup.boolean(),
  repeatDays: Yup.array().when("repeats", {
    is: true,
    then: () =>
      Yup.array()
        .min(1, "Select at least one repeat day")
        .required("Repeat days required"),
    otherwise: () => Yup.array().notRequired(),
  }),
  endCondition: Yup.string().notRequired(),
  specificDate: Yup.string().when("endCondition", {
    is: "specific-date",
    then: () =>
      Yup.string()
        .required("Specific date is required")
        .test("valid-date", "Date is invalid", (value) => !!Date.parse(value)),
    otherwise: () => Yup.string().notRequired(),
  }),
  numberOfEvents: Yup.string().when("endCondition", {
    is: "number-of-events",
    then: () =>
      Yup.number()
        .typeError("Must be a number")
        .positive("Must be a positive number")
        .required("Number of events is required"),

    otherwise: () => Yup.mixed().notRequired(),
  }),
});

const Calendarcontant = ({ info }) => {
  const [appointments, setAppointments] = useState([]);
  const [currentView, setCurrentView] = useState("week");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showAppointmentPanel, setShowAppointmentPanel] = useState(false);
  const [editingAppointmentId, setEditingAppointmentId] = useState(null);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [currentAgendaTab, setCurrentAgendaTab] = useState("Scheduled");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedResource, setSelectedResource] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [calendar, setCalendar] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [clientdata, setclientdata] = useState([]);
  const [providerdata, setproviderdata] = useState([]);
  const [visitReasondata, setvisitReasondata] = useState([]);
  const [addressData, setaddressData] = useState([]);
  const [authorization, setauthorization] = useState(null);
  const [visitstatus, setvisitstatus] = useState([]);
  const [miniSelectedDate, setMiniSelectedDate] = useState(null);
  const [appointmentType, setappointmentType] = useState([]);
  const [clientEmail, setClientEmail] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [isEditingClientEmail, setIsEditingClientEmail] = useState(false);
  const [isEditingClientPhone, setIsEditingClientPhone] = useState(false);
  const [providerEmail, setProviderEmail] = useState("");
  const [providerPhone, setProviderPhone] = useState("");
  const [isEditingProviderEmail, setIsEditingProviderEmail] = useState(false);
  const [isEditingProviderPhone, setIsEditingProviderPhone] = useState(false);
  const [clientEmailError, setClientEmailError] = useState("");
  const [clientPhoneError, setClientPhoneError] = useState("");
  const [providerEmailError, setProviderEmailError] = useState("");
  const [providerPhoneError, setProviderPhoneError] = useState("");
  const [resourcedata, setresourcedata] = useState([]);
  const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
  const [paymentmethoddata, setpaymentmethoddata] = useState([]);
  const [selectedpayment, setselectedpayment] = useState("");
  const [providertimezone, setprovidertimezone] = useState("");
  const [clienttimezone, setclienttimezone] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [activeAppointment, setActiveAppointment] = useState(null);
  const [servicelocation, setServiceLocation] = useState([]);
  const [weeklySchedule, setWeeklySchedule] = useState({
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  });
  const [scheduleData, setScheduleData] = useState();

  console.log(info?.availableDays, "availble====");
  const addTimeBlock = useCallback(
    (day) => {
      const newBlock = {
        start: "08:00",
        end: "17:00",
        location: servicelocation.length > 0 ? servicelocation[0]._id : "",
        _id: null,
        dayId: null,
      };

      setWeeklySchedule((prevState) => {
        const updatedSchedule = {
          ...prevState,
          [day]: [...prevState[day], newBlock],
        };

        if (setScheduleData) {
          setScheduleData(prepareScheduleForSaving(updatedSchedule));
        }

        return updatedSchedule;
      });
    },
    [servicelocation, setScheduleData]
  );

  const removeTimeBlock = useCallback(
    (day, index) => {
      setWeeklySchedule((prevState) => {
        const newDaySchedule = prevState[day].filter((_, i) => i !== index);
        const updatedSchedule = {
          ...prevState,
          [day]: newDaySchedule,
        };

        if (setScheduleData) {
          setScheduleData(prepareScheduleForSaving(updatedSchedule));
        }
        return updatedSchedule;
      });
    },
    [setScheduleData]
  );
  const prepareScheduleForSaving = useCallback(
    (scheduleData = weeklySchedule) => {
      const result = [];

      Object.entries(scheduleData).forEach(([day, shifts]) => {
        if (Array.isArray(shifts) && shifts.length > 0) {
          const validShifts = shifts.filter(
            (shift) => shift.start && shift.end && shift.start !== shift.end
          );

          if (validShifts.length > 0) {
            result.push({
              day,
              _id: shifts[0]?.dayId || null, 
              shifts: validShifts.map((block) => ({
                _id: block._id || null,
                startTime: block.start,
                endTime: block.end,
                location: block.location,
              })),
            });
          }
        }
      });

      return result;
    },
    [weeklySchedule]
  );
  useEffect(() => {
    if (!Array.isArray(info?.availableDays?.availableDays)) return;

    const schedule = {
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
      Saturday: [],
      Sunday: [],
    };

    info?.availableDays?.availableDays.forEach((entry) => {
      const day = entry.day;
      if (schedule.hasOwnProperty(day) && Array.isArray(entry.shifts)) {
        schedule[day] = entry.shifts.map((shift) => ({
          start: shift.startTime || "08:00",
          end: shift.endTime || "17:00",
          location: shift.location || "",
          _id: shift._id || null,
          dayId: entry._id || null,
        }));
      }
    });

    setWeeklySchedule(schedule);
  }, [info?.availableDays?.availableDays]);

  const Savesettings = async () => {
    const data = {
      id: info?.availableDays?._id || null,
      availableDays: prepareScheduleForSaving(),
    };
    console.log(data, "data=-=-");
    try {
      const response = await updateAvailableDays(data);
      console.log(response?.data, "respo=-=-=");
      setShowSettingsModal(false);
      ShowToast(response?.data?.message);
    } catch (error) {
      console.log(error);
    }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhone = (phone) => {
    const regex = /^\d{10}$/;
    return regex.test(phone);
  };

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      patientId: "",
      dob: "",
      doctorId: info._id || "",
      deliveryMode: "",
      date: "",
      startTime: "",
      visitReason: "",
      Duration: "",
      status: "",
      repeatAppointment: "",
      repeats: false,
      serviceLocationId: "",
      paymentSource: "",
      patientIntake: [],
      providerTask: [],
      appointmentResource: "",
      patientConfirmation: {
        emailConfirmation: false,
        phone: clientPhone,
        email: clientEmail,
        SMSConfirmation: false,
        pushNotification: false,
      },
      providerConfirmation: {
        phone: providerPhone,
        email: providerEmail,
        emailConfirmation: false,
        SMSConfirmation: false,
        pushNotification: false,
      },
    },
  });

  const repeats = watch("repeats");
  const selectedType = watch("deliveryMode");

  useEffect(() => {
    generateMiniCalendar(currentMonth.getFullYear(), currentMonth.getMonth());
  }, [currentMonth]);

  const generateMiniCalendar = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();

    let days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }

    for (let d = 1; d <= lastDate; d++) {
      days.push(d);
    }

    setCalendar(days);
  };

  const handleDateClick = (year, month, day) => {
    const clickedDate = new Date(year, month, day);
    clickedDate.setHours(0, 0, 0, 0);

    if (!selectedDate || (selectedDate && selectedEndDate)) {
      setSelectedDate(clickedDate);
      setSelectedEndDate(null);
    } else if (
      selectedDate &&
      !selectedEndDate &&
      clickedDate >= selectedDate
    ) {
      setSelectedEndDate(clickedDate);
    } else {
      setSelectedDate(clickedDate);
      setSelectedEndDate(null);
    }
  };
  const goToPreviousMonth = () => {
    const newMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );
    setCurrentMonth(newMonth);
  };

  const goToNextMonth = () => {
    const newMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );
    setCurrentMonth(newMonth);
  };
  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  const formatDate = (dateObj) => dateObj.toISOString().split("T")[0];

  const filteredAppointments = appointments.filter((app) => {
    if (!selectedDate) return false;

    const appDate = new Date(app.date);
    const start = new Date(selectedDate);
    const end = selectedEndDate ? new Date(selectedEndDate) : null;

    if (!end) {
      const appointmentDateStr = appDate.toISOString().split("T")[0];
      const selectedDateStr = start.toISOString().split("T")[0];
      if (appointmentDateStr !== selectedDateStr) return false;
    }

    if (end) {
      appDate.setHours(0, 0, 0, 0);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      if (appDate < start || appDate > end) return false;
    }
    if (selectedResource && app.appointmentResource !== selectedResource)
      return false;
    if (selectedLocation && app.serviceLocationId?._id !== selectedLocation)
      return false;
    if (selectedReason && app.visitReason?._id !== selectedReason) return false;
    if (selectedStatus && app.appointmentStatus?._id !== selectedStatus)
      return false;
    if (
      selectedAppointmentType &&
      app?.deliveryMode?._id !== selectedAppointmentType
    )
      return false;
    if (selectedpayment && app?.paymentSource !== selectedpayment) return false;

    return true;
  });

  const handleViewChange = (view) => {
    setCurrentView(view);
  };
  const handleDateChange = (direction) => {
    const newDate = new Date(currentDate);

    if (direction === "prev") {
      if (currentView === "day") {
        newDate.setDate(newDate.getDate() - 1);
      } else if (currentView === "week") {
        newDate.setDate(newDate.getDate() - 7);
      } else if (currentView === "month") {
        newDate.setMonth(newDate.getMonth() - 1);
      }
    } else if (direction === "next") {
      if (currentView === "day") {
        newDate.setDate(newDate.getDate() + 1);
      } else if (currentView === "week") {
        newDate.setDate(newDate.getDate() + 7);
      } else if (currentView === "month") {
        newDate.setMonth(newDate.getMonth() + 1);
      }
    } else if (direction === "today") {
      newDate.setTime(new Date().getTime());
    }

    setCurrentDate(newDate);
  };

  const onSubmit = async (formData) => {
    console.log("Raw Form Data:", formData);
    const client = clientdata.find((c) => c._id === formData.patientId);
    const location = addressData.find(
      (loc) => loc._id === formData.serviceLocationId
    );
    const appointmentTypeItem = appointmentType.find(
      (type) => type._id === formData.deliveryMode
    );
    const reason = visitReasondata.find((r) => r._id === formData.visitReason);
    const repeatData =
      formData.repeats === true
        ? {
            repeatAppointment: "Yes",
            repeatDays: formData.repeatDays || [],
            endCondition: formData.endCondition,
            ...(formData.endCondition === "specific-date" && {
              specificDate: formData.specificDate,
            }),
            ...(formData.endCondition === "number-of-events" && {
              numberOfEvents: formData.numberOfEvents,
            }),
          }
        : {
            repeatAppointment: "No",
          };

    const data = {
      ...(authorization?.Auth && { authorizationDetailId: authorization._id }),
      patientRequestId: formData.patientId,
      dob: formData.dob,
      doctorRequestId: formData.doctorId,
      agencyId: profiledata?._id,
      deliveryMode: formData.deliveryMode,
      date: new Date(formData.date).toISOString(),
      startTime: formData.startTime,
      visitReason: formData.visitReason,
      appointmentResource: formData.appointmentResource,
      Duration: formData.duration ? `${formData.duration} minutes` : null,
      appointmentStatus: formData.appointmentStatus,
      serviceLocationId: formData.serviceLocationId,
      paymentSource: formData.paymentSource,
      patientIntake: formData.patientIntake || [],
      providerTask: formData.providerTask || [],
      patientConfirmation: {
        emailConfirmation: formData["email-confirm"] || false,
        SMSConfirmation: formData["sms-confirm"] || false,
        pushNotification: formData["inapp-confirm"] || false,
        phone: clientPhone,
        email: clientEmail,
      },
      providerConfirmation: {
        phone: providerPhone,
        email: providerEmail,
        emailConfirmation: formData["provider-email-confirm"] || false,
        SMSConfirmation: formData["provider-sms-confirm"] || false,
        pushNotification: formData["provider-inapp-confirm"] || false,
      },
      emailData: {
        clientName: client ? `${client.firstName} ${client.lastName}` : "",
        providerName: info ? `${info.firstName} ${info.lastName}` : "",
        appointmentDate: new Date(formData.date).toISOString(),
        appointmentTime: formData.startTime,
        timeZone: providertimezone,
        location: location?.name || "",
        appointmentType: appointmentTypeItem?.name || "",
        visitReason: reason?.visitReason || "",
        paymentSource: formData.paymentSource || "",
        logoUrl: "https://your-domain.com/logo.png",
        telehealthLink: "https://your-telehealth-link.com",
        documentLink: "https://your-document-link.com",
        manageAppointmentLink: "https://your-manage-link.com",
        supportEmail: "support@ennhealth.com",
      },
      ...repeatData,
    };

    console.log("Mapped Data for API:", data);
    try {
      const response = await Postappointments(data);
      console.log(response.data?.data, "respo=-=-=-");
      ShowToast(response.data.message, "success");
      setShowAppointmentPanel(false);
      reset();
      setValue("providerTask", []);
      setValue("patientIntake", []);
      FetchAppointment();
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const Handleselecttask = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("providerTask", ids, { shouldValidate: true });
  };
  const HandleselectpatientIntake = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("patientIntake", ids, { shouldValidate: true });
  };

  // const addTimeBlock = (day) => {
  //   const newBlock = { start: "08:00", end: "17:00", location: "Main Office" };
  //   setWeeklySchedule((prevState) => ({
  //     ...prevState,
  //     [day]: [...prevState[day], newBlock],
  //   }));
  // };

  // const removeTimeBlock = (day, index) => {
  //   setWeeklySchedule((prevState) => {
  //     const newDaySchedule = prevState[day].filter((_, i) => i !== index);
  //     return {
  //       ...prevState,
  //       [day]: newDaySchedule,
  //     };
  //   });
  // };

  const handleTimeBlockChange = (day, index, field, value) => {
    const newSchedule = [...weeklySchedule[day]];
    newSchedule[index][field] = value;
    setWeeklySchedule((prevState) => ({
      ...prevState,
      [day]: newSchedule,
    }));
  };
  const hours = [];
  for (let i = 0; i < 24; i++) {
    if (i === 0) {
      hours.push("12 AM");
    } else if (i === 12) {
      hours.push("12 PM");
    } else if (i < 12) {
      hours.push(`${i} AM`);
    } else {
      hours.push(`${i - 12} PM`);
    }
  }

  const generateCalendarDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay?.getDate();
    const startingDayOfWeek = firstDay?.getDay();

    const days = [];

    const prevMonthLastDay = new Date(year, month, 0).getDate();
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      days.push({
        day: prevMonthLastDay - i,
        isCurrentMonth: false,
        isPrevMonth: true,
      });
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push({
        day: day,
        isCurrentMonth: true,
        isPrevMonth: false,
      });
    }

    const totalCells = 42;
    let nextMonthDay = 1;
    while (days.length < totalCells) {
      days.push({
        day: nextMonthDay++,
        isCurrentMonth: false,
        isPrevMonth: false,
      });
    }

    return days;
  };

  const calendarDays = generateCalendarDays();
  // apis
  const FetchResource = async () => {
    try {
      const respo = await GetResource(profiledata?._id);
      setresourcedata(respo?.data?.data?.results);
    } catch (error) {
      console.log(error);
    }
  };
  const GetClients = async (page) => {
    try {
      let data = {
        limit: 100,
        page: 1,
        agencyId: profiledata?._id,
        status: "approved",
      };
      const response = await Getmyclinicpatient(data);
      setclientdata(response?.data.data?.response);
    } catch (error) {
      console.log(error, "error=====");
    }
  };
  const FetchDoctorrequest = async () => {
    try {
      const response = await GetDoctorsRequest({ status: "approved" });
      setproviderdata(response?.data.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const GetVisitReason = async () => {
    const response = await FetchVisitReason(`?id=${profiledata?._id}`);
    setvisitReasondata(response?.data?.data);
  };
  const GetAppoientmentVisit = async () => {
    const response = await FetchAddAppoientmentVisit(`?id=${profiledata?._id}`);
    setvisitstatus(response?.data?.data);
  };
  const FetchDatalist = async () => {
    try {
      const response = await GetDeliveryMode(`?id=${profiledata?._id}`);
      setappointmentType(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchAddresslist = async () => {
    const data = {
      id: profiledata?._id,
    };
    try {
      const response = await Getserviceaddress(data);
      setaddressData(response?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchAppointment = async () => {
    const data = {
      agencyId: profiledata?._id,
      page: 1,
      limit: 100,
      doctorId: info?._id,
    };
    try {
      const respo = await GetappointmentsbyPut(data);

      setAppointments(respo?.data?.data?.appointments);
    } catch (error) {
      console.log(error, "error---");
    }
  };
  const FetchPaymentlist = async () => {
    try {
      const response = await GetPaymentSources(`?id=${profiledata?._id}`);
      setpaymentmethoddata(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const PatientId = watch("patientId");
  const fetchAuthorizations = async () => {
    try {
      const activeauth = await GetactiveAuth(profiledata?._id, PatientId);
      setauthorization(activeauth?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (PatientId) {
      fetchAuthorizations();
    }
  }, [PatientId]);
  useEffect(() => {
    FetchPaymentlist();
    FetchDoctorrequest();
    FetchAddresslist();
    GetClients();
    GetVisitReason();
    GetAppoientmentVisit();
    FetchAppointment();
    FetchDatalist();
    FetchResource();
  }, []);
  const selectedClientId = watch("patientId");
  const formatDOB = (dobString) => {
    if (!dobString) return "";
    const date = new Date(dobString);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    const client = clientdata.find((c) => c._id === selectedClientId);
    if (client) {
      setValue("dob", formatDOB(client?.DOB));
      setValue("paymentSource", client?.PaymentSourcesId?.name);
      setClientEmail(client?.email || "");
      setClientPhone(client?.phone || "");
      setclienttimezone(client?.TimeZone || "");
    }
  }, [selectedClientId]);
  useEffect(() => {
    if (info) {
      setProviderEmail(info?.email || "");
      setProviderPhone(info?.phone || "");
      setprovidertimezone(info?.TimeZone || "");
    }
  }, [watch("doctorId")]);
  const selectedVisitReasonId = watch("visitReason");
  useEffect(() => {
    if (selectedVisitReasonId) {
      const selected = visitReasondata.find(
        (item) => item._id === selectedVisitReasonId
      );
      if (selected) {
        setValue("duration", selected.appointmentDuration);
        //  setValue("paymentSource", selected.PaymentSourcesId?.name);
      }
    }
  }, [selectedVisitReasonId, visitReasondata, setValue]);

  const startTime = watch("startTime");
  const selectedappointmentDate = watch("date");

  const cleanTimezone = (zone) => {
    if (!zone) return "";
    return zone.replace(/\s*\(GMT.*\)/, "");
  };

  const formatTimeInZone = (dateStr, timeStr, fromZone, toZone) => {
    if (!dateStr || !timeStr || !fromZone || !toZone) return "";

    const cleanFrom = cleanTimezone(fromZone);
    const cleanTo = cleanTimezone(toZone);

    const datetime = moment.tz(
      `${dateStr} ${timeStr}`,
      "YYYY-MM-DD HH:mm",
      cleanFrom
    );
    const converted = datetime.clone().tz(cleanTo);

    return converted.format("hh:mm A z");
  };
  const getAbbreviation = (dateStr, timeStr, zone) => {
    const cleanZone = cleanTimezone(zone);
    const dateTime = moment.tz(
      `${dateStr} ${timeStr || "12:00"}`,
      "YYYY-MM-DD HH:mm",
      cleanZone
    );
    return dateTime.format("z");
  };
  const providerAbbr = getAbbreviation(
    selectedappointmentDate,
    startTime,
    providertimezone
  );
  const clientAbbr = getAbbreviation(
    selectedappointmentDate,
    startTime,
    clienttimezone
  );

  const providerTime = formatTimeInZone(
    selectedappointmentDate,
    startTime,
    providertimezone,
    providertimezone
  );

  const clientTime = formatTimeInZone(
    selectedappointmentDate,
    startTime,
    providertimezone,
    clienttimezone
  );

  return (
    <>
      <div className="container_CalendarView">
        <div className="header-bar_CalendarView">
          <div className="header-left_CalendarView">
            <div className="view-toggle_CalendarView">
              <button
                onClick={() => handleViewChange("week")}
                style={{ marginRight: 5 }}
                className="nav-button_CalendarView"
              >
                Week
              </button>
              <button
                onClick={() => handleViewChange("day")}
                style={{ marginRight: 5 }}
                className="nav-button_CalendarView"
              >
                Day
              </button>
              <button
                onClick={() => handleViewChange("month")}
                style={{ marginRight: 5 }}
                className="nav-button_CalendarView"
              >
                Month
              </button>
              <button
                onClick={() => handleViewChange("agenda")}
                className="nav-button_CalendarView"
              >
                Agenda
              </button>
            </div>
            <button
              onClick={() => handleDateChange("prev")}
              className="nav-button_CalendarView"
            >
              Prev
            </button>
            <button
              onClick={() => handleDateChange("today")}
              className="today-button_CalendarView"
            >
              Today
            </button>
            <button
              onClick={() => handleDateChange("next")}
              className="nav-button_CalendarView"
            >
              Next
            </button>
            <div className="date-range_CalendarView" id="date-range">
              {currentDate.toDateString()}
            </div>
          </div>
          <div>
            <button
              onClick={() => setShowAppointmentPanel(true)}
              className="add-new-button_CalendarView"
            >
              + Create Appointment
            </button>
            <button
              onClick={() => setShowSyncModal(true)}
              className="synch-button_CalendarView"
              style={{ marginLeft: 5, marginRight: 5 }}
            >
              Calendar Synch
            </button>
            <button
              onClick={() => setShowSettingsModal(true)}
              className="settings-button_CalendarView"
            >
              Settings
            </button>
          </div>
        </div>

        <div id="search-container">
          <input
            type="text"
            id="search-input"
            placeholder="Search appointments..."
          />
        </div>

        <div style={{ display: "flex", gap: 20 }}>
          <div className="mini-calendar-container_CalendarView">
            <div className="mini-calendar-container">
              <div className="calendar-header_two">
                <button className="nav-button" onClick={goToPreviousMonth}>
                  &lt;
                </button>
                <span className="month-label">
                  {currentMonth.toLocaleString("default", {
                    month: "long",
                    year: "numeric",
                  })}
                </span>
                <button className="nav-button" onClick={goToNextMonth}>
                  &gt;
                </button>
              </div>

              <table className="calendar-table">
                <thead>
                  <tr>
                    {["S", "M", "T", "W", "T", "F", "S"].map((day) => (
                      <th key={day}>{day}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: Math.ceil(calendar.length / 7) }).map(
                    (_, weekIndex) => (
                      <tr key={weekIndex}>
                        {calendar
                          .slice(weekIndex * 7, weekIndex * 7 + 7)
                          .map((day, idx) => {
                            const fullDate =
                              day &&
                              new Date(
                                currentMonth.getFullYear(),
                                currentMonth.getMonth(),
                                day
                              );
                            const isToday =
                              fullDate && isSameDate(fullDate, new Date());
                            const isStart =
                              fullDate &&
                              selectedDate &&
                              isSameDate(fullDate, selectedDate);
                            const isEnd =
                              fullDate &&
                              selectedEndDate &&
                              isSameDate(fullDate, selectedEndDate);

                            return (
                              <td
                                key={idx}
                                className={`day-cell
                        ${isToday ? "today_date" : ""}
                        ${isStart ? "selected-start" : ""}
                        ${isEnd ? "selected-end" : ""}
                      `}
                                onClick={() =>
                                  day &&
                                  handleDateClick(
                                    currentMonth.getFullYear(),
                                    currentMonth.getMonth(),
                                    day
                                  )
                                }
                              >
                                {day || ""}
                              </td>
                            );
                          })}
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>

            <div className="calendar-filters_CalendarView">
              <div className="form-group_CalendarView">
                <label>Provider:</label>
                <input
                  type="text"
                  value={`${info.firstName} ${info.lastName}`}
                  disabled
                  className="form-control"
                />
              </div>
              <div className="form-group_CalendarView">
                <label>Resource:</label>
                <select
                  value={selectedResource}
                  onChange={(e) => setSelectedResource(e.target.value)}
                >
                  <option value="">-- Select Resource --</option>
                  {resourcedata.map((item) => {
                    return (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Location:</label>
                <select
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                >
                  <option value="">-- Select Location --</option>
                  {addressData.map((item) => {
                    return (
                      <option key={item._id} value={item?._id}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Reason:</label>
                <select
                  value={selectedReason}
                  onChange={(e) => setSelectedReason(e.target.value)}
                >
                  <option value="">-- Select Reason --</option>
                  {visitReasondata.map((item) => {
                    return (
                      <option key={item._id} value={item._id}>
                        {item.visitReason}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Status:</label>
                <select
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="">-- Select Status --</option>
                  {visitstatus.map((item) => {
                    return (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Appointment Type:</label>
                <select
                  value={selectedAppointmentType}
                  onChange={(e) => setSelectedAppointmentType(e.target.value)}
                >
                  <option value="">-- Select type--</option>
                  {appointmentType.map((item, index) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group_CalendarView">
                <label>Payment Method:</label>
                <select
                  value={selectedpayment}
                  onChange={(e) => setselectedpayment(e.target.value)}
                >
                  <option value="">-- Select type--</option>
                  {paymentmethoddata.map((item, index) => (
                    <option key={item._id} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div id="selectedMiniDay">
              {selectedDate
                ? `Selected Date: ${selectedDate.toLocaleDateString("en-GB")}`
                : "No Date Selected"}
            </div>

            <ul id="miniEventList">
              {selectedDate && filteredAppointments.length > 0 ? (
                filteredAppointments.map((app, index) => (
                  <li
                    key={index}
                    onClick={() => alert(`Edit Appointment ${app._id}`)}
                  >
                    {app.startTime} - {app.Duration} |{" "}
                    {app.patientRequestId?.firstName} |{" "}
                    {app.doctorRequestId?.firstName}
                  </li>
                ))
              ) : (
                <li>No appointments for this date.</li>
              )}
            </ul>
          </div>

          <div style={{ flex: 1 }}>
            <div id="calendar-container" />
            {currentView === "week" && (
              <WeekView currentDate={currentDate} appointments={appointments} />
            )}
            {currentView === "day" && (
              <div className="day-view_CalendarView">
                <div className="day-view-header_CalendarView">
                  {currentDate.toDateString()}
                </div>

                <div className="day-scrollable-container">
                  {/* Time Column */}
                  <div className="day-time-column">
                    {hours.map((hour, index) => (
                      <div key={index} className="day-view-time_CalendarView">
                        {hour}
                      </div>
                    ))}
                  </div>

                  <div className="day-content-container">
                    <div className="day-view-rows_CalendarView">
                      {hours.map((hour, index) => {
                        const filteredAppointments = appointments.filter(
                          (app) => {
                            const appDate = new Date(app.date);
                            const viewDate = new Date(currentDate);

                            const isSameDate =
                              appDate.getFullYear() ===
                                viewDate.getFullYear() &&
                              appDate.getMonth() === viewDate.getMonth() &&
                              appDate.getDate() === viewDate.getDate();

                            const appHour = parseInt(
                              (app.startTime || app.start || "00:00").split(
                                ":"
                              )[0],
                              10
                            );

                            return isSameDate && appHour === index;
                          }
                        );

                        return (
                          <div
                            key={index}
                            className="day-view-row_CalendarView"
                          >
                            {filteredAppointments.map((app, i) => (
                              <div
                                key={i}
                                className="appointment-block"
                                onClick={() => setActiveAppointment(app)}
                              >
                                <div className="appointment-label">
                                  Client: {app?.patientRequestId?.firstName}{" "}
                                  {app?.patientRequestId?.lastName}
                                  <br />
                                  Provider: {
                                    app?.doctorRequestId?.firstName
                                  }{" "}
                                  {app?.doctorRequestId?.lastName}
                                  <br />
                                  <button className="ClockIn_Button">
                                    Clock In
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {currentView === "month" && (
              <MonthView
                calendarDays={calendarDays}
                appointments={appointments}
                currentDate={currentDate}
              />
            )}
            {currentView === "agenda" && (
              <AgendaView
                currentView={currentView}
                currentAgendaTab={currentAgendaTab}
                setCurrentAgendaTab={setCurrentAgendaTab}
                appointments={
                  Array.isArray(filteredAppointments) &&
                  filteredAppointments.length > 0
                    ? filteredAppointments
                    : appointments
                }
                miniSelectedDate={miniSelectedDate}
                // joinTelehealth={joinTelehealth}
                // openEditModal={openEditModal}
              />
            )}
          </div>
        </div>
      </div>

      <div
        className={`appointment-panel_CalendarView ${
          showAppointmentPanel ? "show" : ""
        }`}
      >
        <div className="modal-content_CalendarView">
          <span
            className="close_CalendarView"
            onClick={() => setShowAppointmentPanel(false)}
          >
            &times;
          </span>
          <h2 id="modal-title">
            {editingAppointmentId ? "Edit Appointment" : "Add Appointment"}
          </h2>
          <form
            className="form-container_CalendarView"
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* Client Information Section */}
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Client Information
              </div>
              <div>
                <div className="form-group_CalendarView">
                  <label htmlFor="client-select">Select Client:</label>
                  <select id="client-select" {...register("patientId")}>
                    <option value="">-- Select Client --</option>
                    {clientdata.map((client) => (
                      <option key={client._id} value={client._id}>
                        {client.firstName} {client.lastName}
                      </option>
                    ))}
                  </select>
                  {errors.patientId && (
                    <p className="error">{errors.patientId.message}</p>
                  )}
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="client-dob">DOB:</label>
                  <input
                    type="text"
                    id="client-dob"
                    disabled
                    {...register("dob")}
                    value={watch("dob")}
                  />
                </div>
              </div>
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Provider Information
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="providerSelect">Select Provider:</label>
                  <select id="providerSelect" disabled>
                    <option>
                      {info.firstName} {info.lastName}
                    </option>
                  </select>
                  <input
                    type="hidden"
                    value={info._id}
                    {...register("doctorId")}
                  />
                  {errors.doctorId && (
                    <p className="error">{errors.doctorId.message}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Appointment Details
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="appointment-type">Appointment Type:</label>
                  <select
                    id="appointment-type"
                    name="type"
                    // required
                    {...register("deliveryMode")}
                  >
                    <option value="">-- Select --</option>
                    {appointmentType.map((item, index) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {errors.deliveryMode && (
                    <p className="error">{errors.deliveryMode.message}</p>
                  )}
                </div>
                {selectedType === "Telehealth" && (
                  <div className="form-group_CalendarView">
                    <label>Telehealth URL:</label>
                    <a style={{ textAlign: "left" }}>Join Telehealth Session</a>
                  </div>
                )}
              </div>
              <div>
                <div className="form-group_CalendarView">
                  <label htmlFor="date">Date:</label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    // required
                    {...register("date")}
                  />
                  {errors.date && (
                    <p className="error">{errors.date.message}</p>
                  )}
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="form-group_CalendarView">
                    <label htmlFor="time">
                      Start Time (Provider Time Zone - {providerAbbr || "..."}):
                    </label>
                    <input
                      type="time"
                      id="time"
                      name="start"
                      // required
                      {...register("startTime")}
                    />
                    {errors.startTime && (
                      <p className="error">{errors.startTime.message}</p>
                    )}
                  </div>
                  <div style={{ width: 30 }} />
                  <div className="form-group_CalendarView">
                    <label htmlFor="time">
                      {" "}
                      Client Time ({clientAbbr || "..."}):
                    </label>
                    <input
                      type="text"
                      id="clientTime"
                      value={clientTime}
                      disabled
                    />
                  </div>
                </div>
              </div>
              {startTime && selectedappointmentDate && (
                <div>
                  This appointment will display as{" "}
                  <strong>{providerTime}</strong> for the provider and{" "}
                  <strong>{clientTime}</strong> for the client.
                </div>
              )}
              <div>
                <div className="form-group_CalendarView">
                  <label htmlFor="visit-reason">Resource:</label>
                  <select
                    id="visit-reason"
                    name="appointmentResource"
                    {...register("appointmentResource")}
                  >
                    <option value="">-- Select Resource --</option>
                    {resourcedata.map((item) => {
                      return (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.appointmentResource && (
                    <p className="error">
                      {errors.appointmentResource.message}
                    </p>
                  )}
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="visit-reason">Visit Reason:</label>
                  <select
                    id="visit-reason"
                    name="visitReason"
                    {...register("visitReason")}
                  >
                    <option value="">-- Select Visit Reason --</option>
                    {visitReasondata.map((item) => {
                      return (
                        <option key={item._id} value={item._id}>
                          {item.visitReason}
                        </option>
                      );
                    })}
                  </select>
                  {errors.visitReason && (
                    <p className="error">{errors.visitReason.message}</p>
                  )}
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="duration">Duration (in mins):</label>
                  <input
                    type="number"
                    id="duration"
                    name="duration"
                    {...register("duration")}
                    min={1}
                    // required
                  />
                  {errors.duration && (
                    <p className="error">{errors.duration.message}</p>
                  )}
                </div>
              </div>
              {/* New Status Field */}
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="appointment-status">Status:</label>
                  <select
                    id="appointment-status"
                    name="appointmentStatus"
                    // required
                    {...register("appointmentStatus")}
                  >
                    <option value="">-- Select Visit Status --</option>
                    {visitstatus.map((item) => {
                      return (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.appointmentStatus && (
                    <p className="error">{errors.appointmentStatus.message}</p>
                  )}
                </div>
              </div>
            </div>
            {/* Repeat Appointment Section */}
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Repeat Appointment
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="repeats">Repeats:</label>
                  <input
                    type="checkbox"
                    id="repeats"
                    name="repeats"
                    {...register("repeats")}
                    // defaultValue={'No'}
                  />
                </div>
              </div>
              {repeats && (
                <div id="repeat-options">
                  <div className="form-row_CalendarView">
                    <label>Repeat Days:</label>
                    <div className="repeat-days-container_CalendarView">
                      {["sun", "mon", "tue", "wed", "thu", "fri", "sat"].map(
                        (day) => (
                          <label className="day-pill_CalendarView" key={day}>
                            <input
                              type="checkbox"
                              {...register("repeatDays")}
                              value={day}
                            />
                            <span>{day.charAt(0).toUpperCase()}</span>
                          </label>
                        )
                      )}
                    </div>
                    {errors.repeatDays && (
                      <p className="error">{errors.repeatDays.message}</p>
                    )}
                  </div>
                  <div className="form-row_CalendarView">
                    <label>End Condition:</label>
                    <div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="radio"
                          value="end-of-month"
                          {...register("endCondition")}
                          defaultChecked
                          style={{ height: 15, width: 15, marginRight: 20 }}
                        />{" "}
                        <label style={{ marginTop: -1 }}>
                          Until the End of Month
                        </label>
                      </div>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="radio"
                          name="end-condition"
                          value="specific-date"
                          {...register("endCondition")}
                          style={{ height: 15, width: 15, marginRight: 20 }}
                        />{" "}
                        <label style={{ marginTop: -1 }}>Specific Date</label>
                        <input
                          type="date"
                          id="specific-date"
                          {...register("specificDate")}
                          style={{ width: 200, marginLeft: 10 }}
                        />
                      </div>
                      {errors.specificDate && (
                        <p className="error">{errors.specificDate.message}</p>
                      )}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="radio"
                          {...register("endCondition")}
                          value="number-of-events"
                          style={{ height: 15, width: 15, marginRight: 20 }}
                        />{" "}
                        <label>Number of Events</label>
                        <input
                          type="number"
                          id="number-of-events"
                          {...register("numberOfEvents", {
                            valueAsNumber: true,
                          })}
                          placeholder="Enter number of events"
                          style={{ width: 200, marginLeft: 10 }}
                        />
                      </div>
                      {errors.numberOfEvents && (
                        <p className="error">{errors.numberOfEvents.message}</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Service Location Section */}
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Service Details
              </div>
              <div>
                <div className="form-group_CalendarView">
                  <label htmlFor="location">Service Location:</label>

                  <select
                    id="location"
                    name="location"
                    {...register("serviceLocationId")}
                    // required
                  >
                    <option value="">-- Select Service Location --</option>
                    {addressData.map((item) => {
                      return (
                        <option key={item._id} value={item?._id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.serviceLocationId && (
                    <p className="error">{errors.serviceLocationId.message}</p>
                  )}
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="payment">Payment Source:</label>
                  <input
                    type="text"
                    name="payment"
                    // disabled

                    value={watch("paymentSource")}
                    {...register("paymentSource")}
                  />
                  {errors.paymentSource && (
                    <p className="error">{errors.paymentSource.message}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Patient Intake
              </div>

              <DropDownManuCustomMulti
                label="Required Documents:"
                placeholder="Select option"
                options={[
                  { _id: "Medical History", name: "Medical History" },
                  { _id: "Consent Forms", name: "Consent Forms" },
                  {
                    _id: "Basic Information",
                    name: "Basic Information",
                  },
                  { _id: "Billing Profile", name: "Billing Profile" },
                  { _id: "Identification", name: "Identification" },
                  {
                    _id: "Emergency Contacts",
                    name: "Emergency Contacts",
                  },
                  {
                    _id: "Allergies & Medications",
                    name: "Allergies & Medications",
                  },
                  { _id: "Measures & Vitals", name: "Measures & Vitals" },
                  {
                    _id: "Document Upload",
                    name: "Document Upload",
                  },
                ]}
                name="RequiredDocuments"
                id="_id"
                clearErrors={clearErrors}
                onSelect={HandleselectpatientIntake}
                register={register}
              />
              {errors.patientIntake && (
                <p className="error">{errors.patientIntake.message}</p>
              )}
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Provider Task
              </div>

              <DropDownManuCustomMulti
                label="Tasks:"
                placeholder="Select option"
                options={[
                  {
                    _id: "Review Patient History",
                    name: "Review Patient History",
                  },
                  { _id: "Call Patient", name: "Call Patient" },
                  {
                    _id: "Update Records",
                    name: "Update Records",
                  },
                  { _id: "Consult with Team", name: "Consult with Team" },
                ]}
                name="Tasks"
                id="_id"
                clearErrors={clearErrors}
                onSelect={Handleselecttask}
                register={register}
              />
              {errors.providerTask && (
                <p className="error">{errors.providerTask.message}</p>
              )}
            </div>
            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Patient Confirmation Methods
              </div>
              <div className="form-row_CalendarView">
                <label>
                  <input type="checkbox" {...register("email-confirm")} />
                  Send confirmation Email to{" "}
                  {selectedClientId &&
                    (isEditingClientEmail ? (
                      <>
                        <input
                          type="text"
                          value={clientEmail}
                          onChange={(e) => setClientEmail(e.target.value)}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (!validateEmail(clientEmail)) {
                              setClientEmailError("Invalid email address");
                              return;
                            }
                            setClientEmailError("");
                            setIsEditingClientEmail(false);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "black" }}
                          />
                        </button>
                        {clientEmailError && (
                          <p className="error">{clientEmailError}</p>
                        )}
                      </>
                    ) : (
                      <>
                        {clientEmail}
                        <button
                          type="button"
                          onClick={() => setIsEditingClientEmail(true)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black", marginLeft: 10 }}
                          />
                        </button>
                      </>
                    ))}
                </label>
                <label>
                  <input type="checkbox" {...register("sms-confirm")} />
                  Send confirmation SMS to{" "}
                  {selectedClientId &&
                    (isEditingClientPhone ? (
                      <>
                        <input
                          type="text"
                          value={clientPhone}
                          onChange={(e) => setClientPhone(e.target.value)}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (!validatePhone(clientPhone)) {
                              setClientPhoneError(
                                "Phone number must be 10 digits"
                              );
                              return;
                            }
                            setClientPhoneError("");
                            setIsEditingClientPhone(false);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "black" }}
                          />
                        </button>
                        {clientPhoneError && (
                          <p className="error">{clientPhoneError}</p>
                        )}
                      </>
                    ) : (
                      <>
                        {clientPhone}
                        <button
                          type="button"
                          onClick={() => setIsEditingClientPhone(true)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black", marginLeft: 10 }}
                          />
                        </button>
                      </>
                    ))}
                </label>
                <label>
                  <input
                    type="checkbox"
                    id="inapp-confirm"
                    name="inapp-confirm"
                    {...register("inapp-confirm")}
                  />
                  {"  "}
                  Send push notification to the app
                </label>
              </div>
            </div>

            <div className="section_CalendarView">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Provider Confirmation Methods
              </div>
              <div className="form-row_CalendarView">
                <label>
                  <input
                    type="checkbox"
                    {...register("provider-email-confirm")}
                  />
                  Send confirmation Email to{" "}
                  {watch("doctorId") &&
                    (isEditingProviderEmail ? (
                      <>
                        <input
                          type="text"
                          value={providerEmail}
                          onChange={(e) => setProviderEmail(e.target.value)}
                        />
                        {providerEmailError && (
                          <p className="error">{providerEmailError}</p>
                        )}
                        <button
                          type="button"
                          onClick={() => {
                            if (!validateEmail(providerEmail)) {
                              setProviderEmailError("Invalid email address");
                              return;
                            }
                            setProviderEmailError("");
                            setIsEditingProviderEmail(false);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "black" }}
                          />
                        </button>
                      </>
                    ) : (
                      <>
                        {providerEmail}
                        <button
                          type="button"
                          onClick={() => setIsEditingProviderEmail(true)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black", marginLeft: 10 }}
                          />
                        </button>
                      </>
                    ))}
                </label>
                <label>
                  <input
                    type="checkbox"
                    {...register("provider-sms-confirm")}
                  />
                  Send confirmation SMS to{" "}
                  {watch("doctorId") &&
                    (isEditingProviderPhone ? (
                      <>
                        <input
                          type="text"
                          value={providerPhone}
                          onChange={(e) => setProviderPhone(e.target.value)}
                        />
                        {providerPhoneError && (
                          <p className="error">{providerPhoneError}</p>
                        )}
                        <button
                          type="button"
                          onClick={() => {
                            if (!validatePhone(providerPhone)) {
                              setProviderPhoneError(
                                "Phone number must be 10 digits"
                              );
                              return;
                            }
                            setProviderPhoneError("");
                            setIsEditingProviderPhone(false);
                          }}
                        >
                          <i
                            className="fas fa-check"
                            style={{ color: "black" }}
                          />
                        </button>
                      </>
                    ) : (
                      <>
                        {providerPhone}
                        <button
                          type="button"
                          onClick={() => setIsEditingProviderPhone(true)}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "black", marginLeft: 10 }}
                          />
                        </button>
                      </>
                    ))}
                </label>
                <label>
                  <input
                    type="checkbox"
                    id="provider-inapp-confirm"
                    name="provider-inapp-confirm"
                    {...register("provider-inapp-confirm")}
                  />
                  {"  "}
                  Send push notification to provider app
                </label>
              </div>
            </div>

            <div className="button-container_CalendarView">
              <button type="submit" className="confirm-btn_CalendarView">
                Confirm Appointment
              </button>
              <button
                type="button"
                className="decline-btn_CalendarView"
                onClick={() => setShowAppointmentPanel(false)}
              >
                Decline Appointment
              </button>
            </div>
          </form>
        </div>
      </div>

      {showSyncModal && (
        <div id="synch-modal" className="modal_CalendarView">
          <div className="modal-content_CalendarView">
            <span
              className="close_CalendarView"
              onClick={() => setShowSyncModal(false)}
            >
              ×
            </span>
            <h2>Calendar Synchronization</h2>
            <p style={{ textAlign: "left" }}>
              Select your calendar service to synchronize:
            </p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              <button id="sync-google" className="synch-button_CalendarView">
                Google Calendar
              </button>
              <button id="sync-outlook" className="synch-button_CalendarView">
                Outlook
              </button>
              <button id="sync-ical" className="synch-button_CalendarView">
                iCalendar
              </button>
            </div>
          </div>
        </div>
      )}

      {showSettingsModal && (
        <div id="settings-modal" className="modal_CalendarView">
          <div className="modal-content_CalendarView">
            <div className="close_CalendarView">
              <span
                style={{ width: 30 }}
                onClick={() => setShowSettingsModal(false)}
              >
                &times;
              </span>
            </div>
            <h2>Working Hours Settings</h2>
            <p>
              Configure your working hours, locations, and scheduling
              constraints.
            </p>
            <div id="settings-days-container" style={{ marginBottom: 20 }}>
              {Object.keys(weeklySchedule).map((day) => (
                <div key={day} className="day-row_CalendarView">
                  <div className="day-row-header_CalendarView">
                    <strong>{day}</strong>
                    <button
                      type="button"
                      className="add-block-btn_CalendarView"
                      onClick={() => addTimeBlock(day)}
                    >
                      Add Time Block
                    </button>
                  </div>
                  <div className="time-blocks_CalendarView">
                    {weeklySchedule[day].map((block, index) => (
                      <div key={index} className="time-block_CalendarView">
                        <label>Start:</label>
                        <input
                          type="time"
                          value={block.start}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "start",
                              e.target.value
                            )
                          }
                        />
                        <label>End:</label>
                        <input
                          type="time"
                          value={block.end}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "end",
                              e.target.value
                            )
                          }
                        />
                        <label>Location:</label>
                        <select
                          value={block.location}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "location",
                              e.target.value
                            )
                          }
                        >
                          <option value="">-- Select Location --</option>
                          {addressData.map((item) => {
                            return (
                              <option key={item._id} value={item?._id}>
                                {item?.name}
                              </option>
                            );
                          })}
                        </select>
                        <button
                          type="button"
                          className="remove-block-btn_CalendarView"
                          onClick={() => removeTimeBlock(day, index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="section_CalendarView" id="constraints-section">
              <div
                className="section-header_CalendarView"
                style={{ textAlign: "left" }}
              >
                Scheduling Constraints
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="min-gap">
                    Minimum Gap Between Sessions (minutes):
                  </label>
                  <input
                    type="number"
                    id="min-gap"
                    name="min-gap"
                    min={0}
                    defaultValue={15}
                  />
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="max-appointments">
                    Maximum Appointments Per Day:
                  </label>
                  <input
                    type="number"
                    id="max-appointments"
                    name="max-appointments"
                    min={1}
                    defaultValue={8}
                  />
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="max-weekly-appointments">
                    Maximum Appointments Per Week:
                  </label>
                  <input
                    type="number"
                    id="max-weekly-appointments"
                    name="max-weekly-appointments"
                    min={1}
                    defaultValue={40}
                  />
                </div>
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="booking-leadtime">
                    Client Booking Lead Time (Hours):
                  </label>
                  <input
                    type="number"
                    id="booking-leadtime"
                    name="booking-leadtime"
                    min={1}
                    defaultValue={24}
                  />
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="cancellation-leadtime">
                    Cancellation Lead Time (Hours):
                  </label>
                  <input
                    type="number"
                    id="cancellation-leadtime"
                    name="cancellation-leadtime"
                    min={1}
                    defaultValue={24}
                  />
                </div>
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="break-start">Mandatory Break (Start):</label>
                  <input
                    type="time"
                    id="break-start"
                    name="break-start"
                    defaultValue="12:00"
                  />
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="break-end">Mandatory Break (End):</label>
                  <input
                    type="time"
                    id="break-end"
                    name="break-end"
                    defaultValue="13:00"
                  />
                </div>
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="min-appt-duration">
                    Minimum Appointment Duration (Minutes):
                  </label>
                  <input
                    type="number"
                    id="min-appt-duration"
                    name="min-appt-duration"
                    min={1}
                    defaultValue={15}
                  />
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="max-appt-duration">
                    Maximum Appointment Duration (Minutes):
                  </label>
                  <input
                    type="number"
                    id="max-appt-duration"
                    name="max-appt-duration"
                    min={1}
                    defaultValue={60}
                  />
                </div>
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="buffer-before">
                    Buffer Time Before (Minutes):
                  </label>
                  <input
                    type="number"
                    id="buffer-before"
                    name="buffer-before"
                    min={0}
                    defaultValue={5}
                  />
                </div>
                <div className="form-group_CalendarView">
                  <label htmlFor="buffer-after">
                    Buffer Time After (Minutes):
                  </label>
                  <input
                    type="number"
                    id="buffer-after"
                    name="buffer-after"
                    min={0}
                    defaultValue={5}
                  />
                </div>
              </div>
              <div className="form-row_CalendarView">
                <div className="form-group_CalendarView">
                  <label htmlFor="calendar-increment">
                    Calendar Increment (minutes):
                  </label>
                  <select id="calendar-increment" name="calendar-increment">
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15} selected="">
                      15
                    </option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={60}>60</option>
                  </select>
                </div>
              </div>
              <p className="small_CalendarView">
                <em>
                  For advanced constraints (equipment/room availability,
                  multi-provider overlaps, time zone rules, etc.), configure in
                  admin console or add here.
                </em>
              </p>
            </div>

            <div className="button-container_CalendarView">
              <button
                type="button"
                className="save-settings-button_CalendarView"
                onClick={Savesettings}
              >
                Save Settings
              </button>
            </div>
          </div>
        </div>
      )}
      {activeAppointment && (
        <div
          className="modal-overlay_week"
          onClick={() => setActiveAppointment(null)}
        >
          <div
            className="modal-content_week"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="tooltip-card">
              <div className="tooltip-header">
                <div className="tooltip-time">
                  {(() => {
                    if (
                      !activeAppointment.startTime ||
                      !activeAppointment.Duration
                    ) {
                      return activeAppointment.startTime || "N/A";
                    }

                    const start = moment(activeAppointment.startTime, "HH:mm");
                    const durationMinutes = parseInt(
                      activeAppointment.Duration
                    );
                    const end = start.clone().add(durationMinutes, "minutes");

                    return `${start.format("HH:mm")} - ${end.format("HH:mm")}`;
                  })()}
                </div>
                <div
                  className="tooltip-status"
                  style={{
                    backgroundColor:
                      activeAppointment?.appointmentStatus?.color,
                  }}
                >
                  {activeAppointment?.appointmentStatus?.name}
                </div>
              </div>

              <div className="tooltip-patient" style={{ textAlign: "left" }}>
                <strong>
                  {activeAppointment.patientRequestId?.firstName}{" "}
                  {activeAppointment.patientRequestId?.lastName}
                </strong>
                <div>DOB: {activeAppointment.dob || "N/A"}</div>
              </div>

              <hr />

              <div className="tooltip-section" style={{ textAlign: "left" }}>
                <h4>Visit Information</h4>
                <div>
                  <strong>Provider:</strong> Dr.{" "}
                  {activeAppointment.doctorRequestId?.firstName}{" "}
                  {activeAppointment.doctorRequestId?.lastName}
                </div>
                <div>
                  <strong>Appointment Type:</strong>{" "}
                  {activeAppointment.deliveryMode?.name || "N/A"}
                </div>
                <div>
                  <strong>Location:</strong>{" "}
                  {activeAppointment.serviceLocationId?.name || "N/A"}
                </div>
                <div>
                  <strong>Visit Reason:</strong>{" "}
                  {activeAppointment.visitReason?.visitReason || "N/A"}
                </div>
                <div>
                  <strong>Service Code(s):</strong>{" "}
                  {activeAppointment.visitReason?.cptCode || "N/A"}
                </div>
                <div className="patient-intake">
                  <strong>Patient Intake:</strong>
                  <span> Pending </span>
                  <button style={{ color: "black" }}>Resend</button>
                </div>
                <div>
                  <strong>Balance:</strong> $0.00
                </div>
              </div>

              <div className="tooltip-section" style={{ textAlign: "left" }}>
                <h4>Financial Information</h4>
                <div>
                  <strong>Plan:</strong> BCBS FL HMO
                </div>
                <div>
                  <strong>Effective:</strong> Not Specified
                </div>
                <div>
                  <strong>Copay:</strong> $0.00
                </div>
                <div>
                  <strong>Eligibility:</strong> Eligible for visit on 3/07/2025
                  <div className="tooltip-actions">
                    <a href="#">View Report</a>
                    <a href="#">Check Again</a>
                  </div>
                </div>
              </div>

              <div className="tooltip-footer">
                <button style={{ color: "black" }}> Status</button>
                <button style={{ color: "black" }}>Create Note</button>
                <button style={{ color: "black" }}>Actions</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Calendarcontant;
